var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9 6.426a1 1 0 0 1 0-1.414 13.974 13.974 0 0 1 19.8 0 1 1 0 0 1-1.415 1.414c-4.7-4.7-12.27-4.7-16.97 0a1 1 0 0 1-1.415 0zM14 14a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM12 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    fill: "#8A8DAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9h4.02C15.704 9 17 10.296 17 11.98v8.073c0 .022 0 .044-.002.066-.102 1.525-1.402 2.914-2.978 2.914H10c-1.684 0-2.98-1.296-2.98-2.98V11.98C7.02 10.296 8.316 9 10 9zm0 2c-.58 0-.98.4-.98.98v8.073c0 .579.4.98.98.98h4.02c.398 0 .925-.436.98-1.019V11.98c0-.58-.401-.98-.98-.98H10z",
    fill: "#8A8DAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.729 7.84a1 1 0 1 0 1.414 1.414 7.963 7.963 0 0 1 11.314 0A1 1 0 1 0 18.87 7.84a9.963 9.963 0 0 0-14.142 0z",
    fill: "#8A8DAA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteIcon);
export default __webpack_public_path__ + "static/media/remote-icon.eb7661e218b0fe4458c8e03388660074.svg";
export { ForwardRef as ReactComponent };